/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProblemDetails,
  WbsDTO,
} from '../models/index';
import {
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    WbsDTOFromJSON,
    WbsDTOToJSON,
} from '../models/index';

export interface WbsByCommessaRequest {
    idCommessa: number;
}

/**
 * 
 */
export class WBSApi extends runtime.BaseAPI {

    /**
     */
    async wbsByCommessaRaw(requestParameters: WbsByCommessaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WbsDTO>> {
        if (requestParameters['idCommessa'] == null) {
            throw new runtime.RequiredError(
                'idCommessa',
                'Required parameter "idCommessa" was null or undefined when calling wbsByCommessa().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Wbs/{idCommessa}`.replace(`{${"idCommessa"}}`, encodeURIComponent(String(requestParameters['idCommessa']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WbsDTOFromJSON(jsonValue));
    }

    /**
     */
    async wbsByCommessa(requestParameters: WbsByCommessaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WbsDTO> {
        const response = await this.wbsByCommessaRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
